var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 117,
    viewBox: "0 0 184 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 117c50.81 0 92-8.943 92-19.976 0-11.032-41.19-19.975-92-19.975S0 85.992 0 97.024C0 108.057 41.19 117 92 117z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.125 39.266l-29.17-32.822c-1.4-2.238-3.444-3.59-5.597-3.59H60.642c-2.153 0-4.197 1.352-5.597 3.587l-29.17 32.828v26.365h132.25V39.266z",
    stroke: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.637 48.316c0-4.58 2.858-8.362 6.403-8.365h32.085v51.757c0 6.058-3.795 11.024-8.481 11.024H34.356c-4.686 0-8.481-4.968-8.481-11.024V39.951H57.96c3.545 0 6.403 3.776 6.403 8.356v.063c0 4.58 2.889 8.278 6.431 8.278h42.412c3.542 0 6.431-3.732 6.431-8.313v-.02z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  })));
}

export default __webpack_public_path__ + "./fonts/empty-list-icon.35f73d4c91427900b1c0d0aef5ef4506.svg";
export { SvgEmptyListIcon as ReactComponent };